import store from "../store";
import socketAPI from "./socketAPI";
import StoreMatchController from "../store/calendar/controllers/storeMatchController";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

/* ====== INITALIZE NAMESPACE SOCKET COMMUNICATES TO ====== */
const NAMESPACE = "/calendar";

/* ====== SOCKET STATES ====== */
let socketNSP = null;

const calendarSocket = {
  /* ====== INITIALIZE SOCKET ====== */
  async initCalendarSocket() {
    /** Custom listeners defined here because calendarSocket not available before initialization (hoisting) */
    const CUSTOM_LISTENERS = {
      connect: calendarSocket.handleConnect,
      MATCH_CREATED: calendarSocket.handleMatchCreated,
      USER_REMOVED: calendarSocket.handleUserRemoved,
      NEW_USER: calendarSocket.handleNewUser,
      USER_JOINED_SESSION: calendarSocket.handleUserJoinedSession,
      REFRESH_CALENDAR_DATA: calendarSocket.handleCalendarRefresh,
    };
    socketNSP = await socketAPI.initSocketNSP(NAMESPACE, CUSTOM_LISTENERS);
  },

  /**
   * ==========================================================
   * ======================= RECEIVERS ========================
   * ==========================================================
   */

  handleConnect() {},

  async handleMatchCreated(data) {
    await StoreMatchController.handleMatchCreated(data);
  },

  async handleUserRemoved(data) {
    data.currentUserID = AuthStore.user._id;
    await StoreMatchController.handleRemovedUser(data);
  },

  /**
   * @todo NB!!! This comes with a vulnerability of the tech savvy curious person finding out
  who has blocked-excluded them. The code flow exists below to also remove this vulnerability
  but with the cost of every person connected to the calendar who receives a new user
  sending a request to check if there is a blocked-excluded relation. This slows the experience
  and also adds heavy expense to the server. IN THE FUTURE, when we have more time, we should
  take into use a new database system to support effective managing of this sort of data. 
  However, we are *not* obligated to not have any way to access this for now. */
  async handleNewUser(data) {
    /* Get individual user's blocked list and ensure 
    a blocked user is not added to the calendar. */
    const userID = AuthStore.user._id;
    if (data.user && data.user.metadata && data.user.metadata.ID.toString() != userID) {
      const otherUserID = data.user.metadata.ID.toString();
      if (store.state.calendar.blockedExcludedIDs && !store.state.calendar.blockedExcludedIDs.includes(otherUserID)) {
        await StoreMatchController.handleNewUser(data, userID);
      }
      /* const relationCheck = await checkIfBlockedExcludedRelationExists(userID, otherUserID);
      if (relationCheck && relationCheck.success && !relationCheck.relationExists) {
        StoreMatchController.handleNewUser(data, userID);
      } */
    }
  },

  async handleUserJoinedSession(data) {
    data.currentUserID = AuthStore.user._id;
    await StoreMatchController.handleJoinedSession(data);
  },

  /**
   * TEMPORARY FIX to refresh all calendar data from the backend change.
   */
  async handleCalendarRefresh() {
    await StoreMatchController.refreshCalendarData();
  },

  /**
   * ==========================================================
   * ======================== EMITTERS ========================
   * ==========================================================
   */
  async bookOneSlot(dateTimeMS, user, matchedUser, hasBookedSession) {
    const location = window.location;
    const sendData = {
      dateTimeMS,
      user,
      matchedUser,
      hasBookedSession,
      location,
    };
    return await socketNSP.emit("BOOK_ONE_SLOT", sendData);
  },

  async bookManySlots(sendData) {
    sendData.location = window.location;
    return await socketNSP.emit("BOOK_MANY_SLOTS", sendData);
  },

  async cancelOneSlot(dateTimeMS, UID) {
    const location = window.location;
    const sendData = {
      UID,
      dateTimeMS,
      location,
    };
    return await socketNSP.emit("CANCEL_ONE_SLOT", sendData);
  },
};

export default calendarSocket;
